<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>
                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [noDataText]="'Sin Datos'"
                        [hoverStateEnabled]="true"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="false" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Evaluaciones"
                            cellTemplate="cellEvaluaciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        caption="Acuerdos"
                        cellTemplate="cellAcuerdos"
                        alignment="center"
                        [minWidth]="120">

                    </dxi-column>
                        <dxi-column
                            dataField="ciclo"
                            caption="Ciclo">
                        </dxi-column>
                        <dxi-column
                            dataField="descripcion"
                            caption="Nombre del periodo de evaluación">
                        </dxi-column>
                        <dxi-column
                            dataField="fechainicioperiodo"
                            caption="Inicio">
                        </dxi-column>
                        <dxi-column
                            dataField="fechainicioacuerdos"
                            caption="Inicio Acuerdos">
                        </dxi-column>
                        <dxi-column
                            dataField="fechafinacuerdos"
                            caption="Fin Acuerdos">
                        </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellEvaluaciones'">
                            <button class="btn boton botonXS"
                            (click)="Formulario(1,cell.data)">
                            <span> {{'Asignar'}}</span>
                        </button>
                        </div>
                        <div *dxTemplate="let cell of 'cellAcuerdos'">
                            <button class="btn boton botonXS" [matTooltip]="'La configuración de acuerdos se realiza dentro del periodo de evaluación y finaliza el día indicado en Inicio acuerdos'"
                            (click)="Formulario(2,cell.data)">
                            <span> {{'Asignar'}}</span>
                        </button>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>

<div #asignacionevaluacionevaluaciones></div>

